"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12.89 11.56l-3.99-8h-.01c-.17-.32-.5-.55-.89-.55s-.72.23-.89.55H7.1l-4 8h.01c-.06.14-.11.29-.11.45 0 .55.45 1 1 1h8c.55 0 1-.45 1-1 0-.16-.05-.31-.11-.45z"];
//# sourceMappingURL=symbol-triangle-up.js.map